export default class GridOptions {
    constructor(args) {
        var _a, _b, _c, _d, _e;
        this.columns = args.columns;
        this.data = args.data;
        this.eventHandlers = (_a = args.eventHandlers) !== null && _a !== void 0 ? _a : null;
        this.pagination = (_b = args.pagination) !== null && _b !== void 0 ? _b : null;
        this.enableInstantSearch = (_c = args.enableInstantSearch) !== null && _c !== void 0 ? _c : false;
        this.searchableColumns = (_d = args.searchableColumns) !== null && _d !== void 0 ? _d : [];
        this.singleSelect = (_e = args.singleSelect) !== null && _e !== void 0 ? _e : false;
        console.log("GridOptions initialized with eventHandlers:", this.eventHandlers);
    }
}
